function pad(value) {
  return `0${value}`.slice(-2);
}

export function formatDate(date) {
  return `${date.getUTCFullYear()}/${pad(date.getUTCMonth() + 1)}/${pad(
    date.getUTCDate(),
  )}`;
}

export function toLocaleDateString(date, skipDay) {
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: skipDay ? undefined : 'numeric',
    timeZone: 'utc',
  });
}

export function formatDateRange(subscription) {
  const start = formatDate(new Date(subscription.startTime));
  const end = subscription.endTime
    ? formatDate(new Date(subscription.endTime))
    : '∞';
  return `${start} – ${end}`;
}

export function formatTime(dateString) {
  const timeString = dateString.split('T').pop();
  if (timeString === '00:00:00.000Z') {
    return '';
  }
  return timeString.replace('Z', ' UTC');
}

/**
 * Given a date, return a new date that is has 00:00:00 UTC time but shares the same calendar date.
 * A non-zero offset will adjust the date by the given number of days.
 */
export function toUTCDay(local, offset) {
  const year = local.getFullYear();
  const month = local.getMonth();
  const date = local.getDate();
  return new Date(Date.UTC(year, month, date + offset));
}
